import {
  m9 as Long,
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  l6 as numberToLong,
  q5 as compareTo,
  s9 as THROW_CCE,
  r6 as toString,
  u5 as getNumberHashCode,
  s5 as equals,
  f9 as Comparable,
  p5 as classMeta,
  r as DoubleCompanionObject_getInstance,
  c3 as listOf,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.c33_1 = new Long(1, 0);
    this.d33_1 = _DateTime___init__impl__ifgty2(0.0);
    this.e33_1 = 6.21355968E13;
  }
  f33(unix) {
    return _DateTime___init__impl__ifgty2(unix);
  }
  g33(unix) {
    return this.f33(unix.fe());
  }
}
class DateTime {
  constructor(unixMillis) {
    Companion_getInstance();
    this.h33_1 = unixMillis;
  }
  i33(other) {
    return DateTime__compareTo_impl_geo3bs(this.h33_1, other);
  }
  d(other) {
    return DateTime__compareTo_impl_geo3bs_0(this, other);
  }
  toString() {
    return DateTime__toString_impl_cnueje(this.h33_1);
  }
  hashCode() {
    return DateTime__hashCode_impl_yf0bc9(this.h33_1);
  }
  equals(other) {
    return DateTime__equals_impl_qd7s8j(this.h33_1, other);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.j33_1 = new Long(1, 0);
    this.k33_1 = 0.001;
    this.l33_1 = 1.0E-6;
    this.m33_1 = _TimeSpan___init__impl__hqf6tm(0.0);
    var tmp = this;
    DoubleCompanionObject_getInstance();
    tmp.n33_1 = _TimeSpan___init__impl__hqf6tm(NaN);
    this.o33_1 = listOf([60, 60, 24]);
  }
  p33(ms) {
    var tmp0_subject = ms;
    return tmp0_subject === 0.0 ? this.m33_1 : _TimeSpan___init__impl__hqf6tm(ms);
  }
  q33(s) {
    return this.p33(s * get_MILLIS_PER_SECOND());
  }
}
//endregion
function _DateTime___init__impl__ifgty2(unixMillis) {
  return unixMillis;
}
function _DateTime___get_unixMillis__impl__ofxkzp($this) {
  return $this;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _DateTime___get_unixMillisDouble__impl__3dzlsc($this) {
  return _DateTime___get_unixMillis__impl__ofxkzp($this);
}
function _DateTime___get_unixMillisLong__impl__sdx9bd($this) {
  return numberToLong(_DateTime___get_unixMillisDouble__impl__3dzlsc($this));
}
function DateTime__compareTo_impl_geo3bs($this, other) {
  return compareTo(_DateTime___get_unixMillis__impl__ofxkzp($this), _DateTime___get_unixMillis__impl__ofxkzp(other));
}
function DateTime__compareTo_impl_geo3bs_0($this, other) {
  var tmp = $this.h33_1;
  return DateTime__compareTo_impl_geo3bs(tmp, other instanceof DateTime ? other.h33_1 : THROW_CCE());
}
function DateTime__toString_impl_cnueje($this) {
  return 'DateTime(' + toString(_DateTime___get_unixMillisLong__impl__sdx9bd($this)) + ')';
}
function DateTime__hashCode_impl_yf0bc9($this) {
  return getNumberHashCode($this);
}
function DateTime__equals_impl_qd7s8j($this, other) {
  if (!(other instanceof DateTime))
    return false;
  var tmp0_other_with_cast = other instanceof DateTime ? other.h33_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var KlockLocale_default;
function _TimeSpan___init__impl__hqf6tm(milliseconds) {
  return milliseconds;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function get_MILLIS_PER_SECOND() {
  return MILLIS_PER_SECOND;
}
var MILLIS_PER_SECOND;
var ExtendedTimezoneNamesOrNull;
//region block: post-declaration
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(DateTime, 'DateTime', classMeta, VOID, [Comparable]);
setMetadataFor(Companion_0, 'Companion', objectMeta);
//endregion
//region block: init
KlockLocale_default = null;
MILLIS_PER_SECOND = 1000;
ExtendedTimezoneNamesOrNull = null;
//endregion
//region block: exports
export {
  DateTime__hashCode_impl_yf0bc9 as a,
  Companion_getInstance as b,
  Companion_getInstance_0 as c,
  DateTime as d,
};
//endregion

//# sourceMappingURL=korge-root-klock.mjs.map
